// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import { BaseScheduleSubmissionModalLayoutCoachFragmentDoc } from './BaseScheduleSubmissionModalLayout.generated';
import {
  BaseScheduleModalLayoutCoachingSessionFragmentDoc,
  BaseScheduleModalLayoutOrderFragmentDoc,
} from './BaseScheduleModalLayout.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CoachCalendarCoachFragment = {
  __typename?: 'Coach';
  id: string;
  slug: string;
  averageReviewRate: number;
  reviewTotal: number;
  newExperience?: boolean | null;
  couldScheduleIntro?: boolean | null;
  everHadCoachingSessionWithCoach?: boolean | null;
  hourlyRate?: number | null;
  tier: Types.SkuTier;
  user: {
    __typename?: 'User';
    id: string;
    firstName: string;
    lastName: string;
    pictureLink?: string | null;
  };
  coachingRelationship?: {
    __typename?: 'CoachingRelationship';
    id: string;
    paidTimeInMinute?: number | null;
    customerSubscription?: {
      __typename?: 'CustomerSubscription';
      id: string;
      sku: { __typename?: 'Sku'; id: string; family: Types.SkuFamily };
    } | null;
  } | null;
  availability?: {
    __typename?: 'CoachAvailability';
    nextAvailableAt?: number | null;
  } | null;
  coachingTimeSummary?: {
    __typename?: 'CoachingTimeSummary';
    availableTime: number;
    hasUnlimitedPackage: boolean;
    cycles?: Array<{
      __typename?: 'SubscriptionCycle';
      start?: number | null;
      end?: number | null;
      timeInMinute: number;
    }> | null;
  } | null;
};

export type CoachCalendarCoachingSessionFragment = {
  __typename?: 'CoachingSession';
  id: string;
  startAt: number;
  endAt: number;
  durationInMinute: number;
  content:
    | { __typename: 'Class'; id: string; name?: string | null }
    | {
        __typename: 'OneOnOneSession';
        title: string;
        introOrder?: {
          __typename?: 'Order';
          introCall?: {
            __typename?: 'IntroCall';
            packages?: Array<{
              __typename?: 'OfferingPackage';
              id: string;
            }> | null;
          } | null;
        } | null;
      };
  coach: {
    __typename?: 'Coach';
    id: string;
    user: { __typename?: 'User'; id: string; firstName: string };
  };
};

export type CoachCalendarAvailabilityQueryVariables = Types.Exact<{
  coachUrn: Types.Scalars['CoachUrn']['input'];
  dateRange?: Types.InputMaybe<Types.LongRangeInput>;
  minRangeInMinutes?: Types.Scalars['Int']['input'];
}>;

export type CoachCalendarAvailabilityQuery = {
  __typename?: 'Query';
  coachCalendarAvailability?: Array<{
    __typename?: 'LongRange';
    start?: number | null;
    end?: number | null;
  }> | null;
};

export const CoachCalendarCoachFragmentDoc = gql`
  fragment CoachCalendar_Coach on Coach {
    id
    user {
      id
      firstName
      lastName
      pictureLink
    }
    coachingRelationship {
      id
      paidTimeInMinute
    }
    availability {
      nextAvailableAt
    }
    coachingTimeSummary {
      cycles {
        start
        end
        timeInMinute
      }
    }
    ...BaseScheduleSubmissionModalLayout_Coach
  }
  ${BaseScheduleSubmissionModalLayoutCoachFragmentDoc}
`;
export const CoachCalendarCoachingSessionFragmentDoc = gql`
  fragment CoachCalendar_CoachingSession on CoachingSession {
    ...BaseScheduleModalLayout_CoachingSession
  }
  ${BaseScheduleModalLayoutCoachingSessionFragmentDoc}
`;
export const CoachCalendarAvailabilityDocument = gql`
  query CoachCalendar_Availability(
    $coachUrn: CoachUrn!
    $dateRange: LongRangeInput
    $minRangeInMinutes: Int! = 30
  ) {
    coachCalendarAvailability(
      coachUrn: $coachUrn
      dateRange: $dateRange
      minRangeInMinutes: $minRangeInMinutes
    ) {
      start
      end
    }
  }
`;

/**
 * __useCoachCalendarAvailabilityQuery__
 *
 * To run a query within a React component, call `useCoachCalendarAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoachCalendarAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoachCalendarAvailabilityQuery({
 *   variables: {
 *      coachUrn: // value for 'coachUrn'
 *      dateRange: // value for 'dateRange'
 *      minRangeInMinutes: // value for 'minRangeInMinutes'
 *   },
 * });
 */
export function useCoachCalendarAvailabilityQuery(
  baseOptions: Apollo.QueryHookOptions<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  > &
    (
      | { variables: CoachCalendarAvailabilityQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  >(CoachCalendarAvailabilityDocument, options);
}
export function useCoachCalendarAvailabilityLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  >(CoachCalendarAvailabilityDocument, options);
}
export function useCoachCalendarAvailabilitySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    CoachCalendarAvailabilityQuery,
    CoachCalendarAvailabilityQueryVariables
  >(CoachCalendarAvailabilityDocument, options);
}
export type CoachCalendarAvailabilityQueryHookResult = ReturnType<
  typeof useCoachCalendarAvailabilityQuery
>;
export type CoachCalendarAvailabilityLazyQueryHookResult = ReturnType<
  typeof useCoachCalendarAvailabilityLazyQuery
>;
export type CoachCalendarAvailabilitySuspenseQueryHookResult = ReturnType<
  typeof useCoachCalendarAvailabilitySuspenseQuery
>;
export type CoachCalendarAvailabilityQueryResult = Apollo.QueryResult<
  CoachCalendarAvailabilityQuery,
  CoachCalendarAvailabilityQueryVariables
>;
